module.exports = __webpack_public_path__ + "static/vista-9-4f1f9c84f108382ca9e1965a79d7a1b6.png";